/**
 * @generated SignedSource<<54282f7b5aee88517f7d47a584b0941c>>
 * @relayHash 52309547e55b39b8ebca1abe76437e05
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9b511e08c69cd7827cb9cb410af68fa13d59c8373bcb7be3b8a5fd68f9304993

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type srcFieldConfigurationSchemesQuery$variables = {
  cloudId: string;
};
export type srcFieldConfigurationSchemesQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"ui_adminPagesFieldConfigurationSchemes_FieldConfigurationSchemesPage">;
  };
};
export type srcFieldConfigurationSchemesQuery = {
  response: srcFieldConfigurationSchemesQuery$data;
  variables: srcFieldConfigurationSchemesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "srcFieldConfigurationSchemesQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "ui_adminPagesFieldConfigurationSchemes_FieldConfigurationSchemesPage"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "srcFieldConfigurationSchemesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              }
            ],
            "concreteType": "JiraHomePage",
            "kind": "LinkedField",
            "name": "userHomePage",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "link"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9b511e08c69cd7827cb9cb410af68fa13d59c8373bcb7be3b8a5fd68f9304993",
    "metadata": {},
    "name": "srcFieldConfigurationSchemesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "789159df1c4fe4cca65de23212d77454";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
